import React from "react";
import { Route, Routes } from "react-router-dom";
import { select, onscroll, scrollTo } from './shared/utils';
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

import 'swiper/css';
import 'swiper/css/bundle';

import "./App.css";

class App extends React.Component {
    componentDidMount() {
        let button = select(".back-to-top");
        if (button) {
            const toggleBackToTop = () => {
                if (window.scrollY > 100) {
                    button.classList.add("active");
                } else {
                    button.classList.remove("active");
                }
            };
            window.addEventListener("load", toggleBackToTop);
            onscroll(document, toggleBackToTop);
        }


        window.addEventListener("load", () => {
            if (window.location.hash) {
                if (select(window.location.hash)) {
                    scrollTo(window.location.hash);
                }
            }
        });
    }

    backToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    render() {
        return (
            <div className="app">
                <Header></Header>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
                <Footer></Footer>

                <button
                    className="back-to-top d-flex align-items-center justify-content-center"
                    onClick={this.backToTop} title="Back To Top">
                    <i className='bx bx-up-arrow-alt'></i>
                </button>
            </div>
        );
    }
}

export default App;
